import { Fragment } from 'react';
import { useInView } from 'react-intersection-observer';

import classNames from 'classnames';

import { Spinner } from '@uikit';

import { useAppValidationVotersListInfiniteQuery } from '@query';

import formatUsername from '@shared/helpers/formatUsername';

import Avatar from '@store:web/components/common/Avatar/Avatar';

interface AppValidationVotersInfiniteListProps {
  appId: string;
  className?: string;
}

// TODO: figure out why InView component not triggers
const AppValidationVotersInfiniteList = ({
  appId,
  className,
}: AppValidationVotersInfiniteListProps) => {
  const {
    data: votes,
    fetchNextPage,
    hasNextPage,
    isLoading,
  } = useAppValidationVotersListInfiniteQuery({ id: appId });
  const { ref } = useInView({
    onChange: (inView) => inView && fetchNextPage(),
  });

  return (
    <ul className={classNames('flex flex-col', className)}>
      {isLoading && (
        <li className="w-full flex items-center justify-center self-center justify-self-center p-2">
          <Spinner size="md" />
        </li>
      )}

      {!isLoading && (
        <>
          {votes?.pages?.map((page, pageIndex) => (
            <Fragment key={pageIndex}>
              {page.votes.map((vote) => (
                <li
                  key={vote.wallet}
                  className="flex justify-between items-center gap-5 py-2"
                  data-qa="validation-vote-row"
                >
                  <Avatar
                    userInfo={vote}
                    src={vote.icon}
                    sizeInPX={32}
                    containerClassName="flex items-center min-w-0 gap-2"
                    data-qa="validation-vote-row-image"
                  >
                    <span className="truncate t-body2" data-qa="validation-vote-row-name">
                      {formatUsername(vote, vote.wallet)}
                    </span>
                  </Avatar>

                  <span
                    className="inline-flex items-center justify-center min-w-[36px] h-6 t-body4 rounded-full"
                    data-qa="validation-vote-row-choice"
                  >
                    {vote.choice}
                  </span>
                </li>
              ))}
            </Fragment>
          ))}
          {hasNextPage && (
            // Key is added to trigger inView cb again if component is already in view
            <li
              key={votes?.pages.length}
              ref={ref}
              className="w-full flex items-center justify-center p-2"
            >
              <Spinner size="md" />
            </li>
          )}
        </>
      )}
    </ul>
  );
};

export default AppValidationVotersInfiniteList;
